import { Box, Skeleton } from '@nimbus-ds/components';
import { DataList } from '@nimbus-ds/patterns';
import { Repeater } from 'commons/components';

export function TransferListRowSkeleton() {
  return (
    <DataList.Row backgroundColor="transparent">
      <Box display="flex" flexDirection="column" gap="0-5">
        <Repeater
          times={5}
          item={() => <Skeleton width="160px" height="16px" />}
        />
      </Box>
    </DataList.Row>
  );
}

export default TransferListRowSkeleton;
